var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWorldIcon = function SvgWorldIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58008 0.25C3.13008 0.25 0.330078 3.05 0.330078 6.5C0.330078 9.95 3.13008 12.75 6.58008 12.75C10.0301 12.75 12.8301 9.95 12.8301 6.5C12.8301 3.05 10.0301 0.25 6.58008 0.25ZM5.95508 11.4563C3.48633 11.15 1.58008 9.05 1.58008 6.5C1.58008 6.1125 1.63008 5.74375 1.71133 5.38125L4.70508 8.375V9C4.70508 9.6875 5.26758 10.25 5.95508 10.25V11.4563ZM10.2676 9.86875C10.1051 9.3625 9.64258 9 9.08008 9H8.45508V7.125C8.45508 6.78125 8.17383 6.5 7.83008 6.5H4.08008V5.25H5.33008C5.67383 5.25 5.95508 4.96875 5.95508 4.625V3.375H7.20508C7.89258 3.375 8.45508 2.8125 8.45508 2.125V1.86875C10.2863 2.6125 11.5801 4.40625 11.5801 6.5C11.5801 7.8 11.0801 8.98125 10.2676 9.86875Z",
    fill: "black",
    fillOpacity: 0.54
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorldIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/worldIcon.f21dbfe4.svg";
export { ForwardRef as ReactComponent };